import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bf-courses-filter"
}
const _hoisted_2 = { class: "row justify-content-lg-center align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-lg-block col-lg-2" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "col-12 col-md-4 col-lg-4 col-xl-3 mb-1 mb-md-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Alle Parks", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "col-12 col-md-4 col-lg-4 col-xl-3 mb-1 mb-md-0"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Alle Kurstypen", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-12 col-md-4 col-lg-2 d-flex justify-content-md-end flex-md-row-reverse" }
const _hoisted_11 = {
  key: 0,
  class: "pe-3 pe-md-0 ps-md-3",
  style: {"cursor":"pointer"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times",
  style: {"font-size":"24px","vertical-align":"-0.12em"}
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "d-md-none ms-2" }, "Filter zurücksetzen", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.locations?.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.locationSelection) = $event))
                }, [
                  _hoisted_5,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: location.value,
                      value: location.value
                    }, _toDisplayString(location.label), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.locationSelection]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.courseTypes?.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.courseTypeSelection) = $event))
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTypes, (courseType) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: courseType.value,
                      value: courseType.value
                    }, _toDisplayString(courseType.label), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.courseTypeSelection]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.currentCourseCount !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.currentCourseCount + ' ' + (_ctx.currentCourseCount === 1 ? 'Kurs' : 'Kurse')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["prevent"])),
              href: "#",
              class: "ms-auto ms-md-0",
              style: _normalizeStyle(_ctx.resetVisible ? '' : 'visibility:hidden;')
            }, _hoisted_14, 4)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}